import { render, staticRenderFns } from "./AsterikaVideo.vue?vue&type=template&id=7abce8c8&scoped=true&lang=html"
import script from "./AsterikaVideo.vue?vue&type=script&lang=js"
export * from "./AsterikaVideo.vue?vue&type=script&lang=js"
import style0 from "./AsterikaVideo.vue?vue&type=style&index=0&id=7abce8c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7abce8c8",
  null
  
)

export default component.exports